import { getMarketplaceCurrencySymbol } from './format-marketplace-price.util';

export class CurrencyUtils {
  static getCurrencySymbol(currencyCode: string): string {
    return getMarketplaceCurrencySymbol(currencyCode);
  }
}
